{
  "conversations": {
    "conversationsApp": "Application Conversations",
    "locationId": "ID de l'emplacement",
    "idToken": "ID de jeton",
    "conversationRoutes": "Itinéraires de conversation",
    "conversationProviders": "fournisseurs de conversations",
    "viewTheListOfConversation": "Affichage de la liste de conversations personnalisées ajoutées au compte ici.",
    "logo": "logo",
    "name": "Nom",
    "alias": "alias",
    "type": "saisir"
  }
}
